import {Injectable} from "@angular/core";
import {AceLogger} from "@logging/ace-logger";
import {AceLoggerService} from "@logging/ace-logger.service";
import {ColumnOption, stringify} from 'csv-stringify/browser/esm/sync';
import {HtmlUtils} from "@shared/util/general/html-utils";


export interface ExportOptions {
  filename: string;
  columns: ColumnOption[],
  header?: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class CsvExportService {

  private readonly logger: AceLogger;

  constructor(private htmlUtils: HtmlUtils, logService: AceLoggerService) {
    this.logger = logService.create(CsvExportService.name);
  }

  downloadCsvData(data: object[], options: ExportOptions) {
    this.logger.debug('generating downloadable csv data');
    const csvData = stringify(data, { columns: options.columns, header: options.header });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf8;' });
    const url = URL.createObjectURL(blob);
    this.htmlUtils.downloadFile(options.filename, url);
  }
}
